module.exports = __webpack_public_path__ + "img/HU22540054.f3438f0f.png";